import React from 'react';
import DateUtils from '../../../lib/DateUtils';
import Button from '../editors/mui/Button';
import { Cached as RefreshIcon } from '@mui/icons-material';
import { FILE_LIST_MODE_TYPES } from '../../../constants/paginationConstants';

const styles = {
  buttonText: {
    fontSize: 10,
  },
  buttonStyle: {
    width: 'auto',
    lineHeight: '30px',
    height: 'auto',
    marginRight: 0,
    marginLeft: 10,
    border: 4,
    padding: 0,
  },
};

function FilesStats({ mode, onRefresh, data = {} }) {
  const {
    numFiles,
    numCompletedFiles,
    partialSuccessFiles,
    notStartedFiles,
    numErrorFiles,
    lastUpdated,
  } = data;

  const titleLabel = mode === FILE_LIST_MODE_TYPES.MODE_WRITE ? 'Write Status' : 'Read Status';
  const delayedFileText =
    mode === FILE_LIST_MODE_TYPES.MODE_READ && (!numFiles || numFiles < 1) ? (
      <div className="scanning-progress-text-holder" style={{ color: '#000' }}>
        File listing can take up to 5 minutes after source creation
      </div>
    ) : null;

  return (
    <div className="scanning-progress-holder">
      <div className="scanning-progress-text-holder">
        <h3>{titleLabel}</h3>
        <Button
          buttonTheme="cancel"
          startIcon={<RefreshIcon fontSize="large" htmlColor="#6D7E8F" />}
          rootStyle={styles.buttonStyle}
          onClick={onRefresh}
        >
          <span style={styles.buttonText}>Refresh</span>
        </Button>
      </div>
      <div className="scanning-progress-text-holder">
        <div>
          Total: <span className="num-total-files">{numFiles}</span>
        </div>
        <div>
          Complete: <span className="num-scanned-files">{numCompletedFiles}</span>
        </div>
        <div>
          Partial Success: <span className="num-total-files">{partialSuccessFiles}</span>
        </div>
        <div>
          Queued: <span className="num-total-files">{notStartedFiles}</span>
        </div>
        <div>
          Error: <span className="num-total-files">{numErrorFiles}</span>
        </div>
      </div>
      <div className="scanning-progress-text-holder" style={{ alignSelf: 'flex-end' }}>
        <span>
          Fetched at:{' '}
          {DateUtils.convertDateStringToFormat(lastUpdated, 'MMM D, YYYY [at] h:mma z', true, true)}
        </span>
      </div>
      {delayedFileText}
    </div>
  );
}

export default FilesStats;
